webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Timer__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Game__ = __webpack_require__(21);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_0__components_Timer__["a" /* default */], Game: __WEBPACK_IMPORTED_MODULE_1__components_Game__["a" /* default */]
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Timer',
    data: function data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        };
    }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            timeMove: 30, // in s
            buttonName: 'START',
            lr: ['left', 'right'],
            baserMoves: ['foot', 'hand'],
            flyerMoves: ['shin', 'foot', 'hip', 'shoulder', 'hand', 'leg'],
            baserMove: '-',
            flyerMove: '-',
            date: null,
            gameRunning: false,
            rulesShown: false,
            now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000)
        };
    },
    mounted: function mounted() {
        var self = this;
        window.setInterval(function () {
            self.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
        }, 1000);
    },

    computed: {
        seconds: function seconds() {
            return this.getDifference() % 60;
        },
        minutes: function minutes() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.getDifference() / 60) % 60;
        }
    },
    methods: {
        setMoves: function setMoves() {
            if (!this.gameRunning) {
                this.gameRunning = true;
            }
            this.buttonName = 'NEXT';
            this.baserMove = this.generateMove(this.baserMoves);
            this.flyerMove = this.generateMove(this.flyerMoves);
            // reset timer, -20 because it makes one more sec
            this.date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((new Date().getTime() + parseInt(this.timeMove * 1000) - 100) / 1000);
        },
        generateMove: function generateMove(moves) {
            var lrItem = this.lr[Math.floor(Math.random() * this.lr.length)];
            var item = moves[Math.floor(Math.random() * moves.length)];
            return lrItem + ' ' + item;
        },
        getDifference: function getDifference() {
            var diff = this.date - this.now;

            return diff <= 0 ? 0 : diff;
        },
        showRules: function showRules() {
            this.rulesShown = true;
        },
        hideRules: function hideRules() {
            this.rulesShown = false;
        },
        restart: function restart() {
            this.gameRunning = false;
            this.baserMove = '-';
            this.flyerMove = '-';
            this.buttonName = 'START';
            this.date = null;
        }
    }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(15);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('two_digits', function (value) {
    if (value.toString().length <= 1) {
        return "0" + value.toString();
    }
    return value.toString();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
    template: '<App/>'
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b2e1fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b2e1fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2486319d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__ = __webpack_require__(20);
function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2486319d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2486319d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"timer"}},[_c('p',{staticClass:"time"},[_vm._v("0:00")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Game_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7617db91_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Game_vue__ = __webpack_require__(36);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7617db91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Game_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7617db91_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Game_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"game"}},[_c('h1',{staticClass:"text-center",attrs:{"id":"title"}},[_vm._v("Acrotwister")]),_vm._v(" "),_c('div',{attrs:{"id":"timer"}},[_c('p',{staticClass:"time",class:{ red: _vm.seconds == 0 }},[_vm._v(_vm._s(_vm._f("two_digits")(_vm.minutes))+" : "+_vm._s(_vm._f("two_digits")(_vm.seconds)))])]),_vm._v(" "),_c('div',{attrs:{"id":"time-input"}},[_c('label',{attrs:{"for":"timeInput"}},[_vm._v("Time for move:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeMove),expression:"timeMove"}],attrs:{"id":"timeInput","type":"text","placeholder":"0"},domProps:{"value":(_vm.timeMove)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timeMove=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("s")])]),_vm._v(" "),_c('div',{attrs:{"id":"rules"}},[_c('button',{staticClass:"rules-btn",on:{"click":_vm.showRules}},[_vm._v("Rules")])]),_vm._v(" "),_c('div',{class:{ visibleBlock: _vm.rulesShown },attrs:{"id":"overlay"},on:{"click":_vm.hideRules}},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-xs-6",attrs:{"id":"baser-box"}},[_c('p',{staticClass:"move"},[_vm._v(_vm._s(_vm.baserMove))]),_vm._v(" "),_c('p',{staticClass:"role-title"},[_vm._v("BASER")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-xs-6",attrs:{"id":"flyer-box"}},[_c('p',{staticClass:"move"},[_vm._v(_vm._s(_vm.flyerMove))]),_vm._v(" "),_c('p',{staticClass:"role-title"},[_vm._v("FLYER")])])]),_vm._v(" "),_c('button',{staticClass:"next-btn",on:{"click":_vm.setMoves}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('button',{staticClass:"restart-btn",class:{ visible: _vm.gameRunning },on:{"click":_vm.restart}},[_c('i',{staticClass:"fas fa-redo-alt"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rules-overlay"}},[_c('h2',[_vm._v("Acrotwister Rules")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Game is played in pairs "),_c('b',[_vm._v("baser")]),_vm._v(" and "),_c('b',[_vm._v("flyer")]),_vm._v(" and these pairs compete until the last pair, winning one is playing")]),_vm._v(" "),_c('p',[_vm._v("1. All pairs start in starting position which is: "),_c('b',[_vm._v("front bird")]),_vm._v(", "),_c('b',[_vm._v("throne")]),_vm._v(" or "),_c('b',[_vm._v("any AcroYoga pose.")])]),_vm._v(" "),_c('p',[_vm._v("2. Then the time for the round could be set, initially it is 30 seconds and game starts with pushing "),_c('i',[_vm._v("START")]),_vm._v(" button.")]),_vm._v(" "),_c('p',[_vm._v("3. Pairs have given time to perform the move in the given conditions, without using the help of the other limbs and all previous connections stays on the place.\n                "),_c('br'),_c('i',[_vm._v("Example:")]),_vm._v(" Pair starts in front bird and after pressing "),_c('i',[_vm._v("START")]),_vm._v(", moves are generated, "),_c('b',[_vm._v("baser")]),_vm._v(" has left leg and "),_c('b',[_vm._v("flyer")]),_vm._v(" right shoulder. Baser moves his left leg to right shoulder of the flyer without using any other limb and the right leg stays on the left hip of the flyer.")]),_vm._v(" "),_c('p',[_vm._v("4. After completion of the move "),_c('i',[_vm._v("NEXT")]),_vm._v(" button is pressed and new move is generated. All previous connections are kept.")]),_vm._v(" "),_c('p',[_vm._v("5. In case the pair has fallen down or didn't complete the move in given time pair is out of the game.")]),_vm._v(" "),_c('p',[_vm._v("6. Last pair standing wins the game.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Enjoy the game!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Game')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.3d20eac1186ada2195b3.js